import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

import Gstm from './dialogs/gstm.js';
import MelTextureGuesser from './dialogs/melTextureGuesser.js';
import Portfolio from './dialogs/portfolio.js';
import SweetAiChat from './dialogs/sweetaichat.js';
import FakeTradiing from './dialogs/faketradiing.js';

import './personnal.css'

export default function Personnal() {

    const { t } = useTranslation();

    const [gstmVisible, setGstmVisible] = useState(false);
    const [melTextureGuesserVisible, setMelTextureGuesserVisible] = useState(false);
    const [portfolioVisible, setPortfolioVisible] = useState(false);
    const [sweetAiChatVisible, setSweetAiChatVisible] = useState(false);
    const [fakeTradiingVisible, setFakeTradiingVisible] = useState(false);

    return (
        <>
            <div className="back-container-white pt-1 relative pb-6">
                <h2 className="text-center titles text-pink-200">{t("personnalProjects")}</h2>
                
                
                <div className="flex justify-content-center w-full">
                    <div className="grid w-8">
                        <div className="col personnalCol">
                            <h2 className="text-center titles text-800 mb-1">FakeTradiing</h2>
                            <Card className="personnal-card border-800 fakeTradiingCard cursor-pointer" onClick={() => setFakeTradiingVisible(true)}>
                                <div></div>

                                <div className="w-full flex justify-content-center bottom-0">
                                    <Button label="Details" className="mt-3 cardButton" onClick={() => setFakeTradiingVisible(true)} outlined/>
                                </div>
                            </Card>
                        </div>
                        {/*<div className="col personnalCol">
                            <h2 className="text-center titles text-pink-200 mb-1">SweetAiChat</h2>
                            <Card className="personnal-card border-pink-200 sweetAiChatCard cursor-pointer" onClick={() => setSweetAiChatVisible(true)}>
                                <div></div>

                                <div className="w-full flex justify-content-center bottom-0">
                                    <Button label="Details" className="mt-3 cardButton" onClick={() => setSweetAiChatVisible(true)} outlined/>
                                </div>
                            </Card>
                        </div>*/}
                        <div className="col personnalCol">
                            <h2 className="text-center titles text-orange-500 mb-1">Portfolio</h2>
                            <Card className="personnal-card border-orange-500 portfolioCard cursor-pointer" onClick={() => setPortfolioVisible(true)}>
                                <div></div>

                                <div className="w-full flex justify-content-center bottom-0">
                                    <Button label="Details" className="mt-3 cardButton" onClick={() => setPortfolioVisible(true)} outlined/>
                                </div>
                            </Card>
                        </div>
                        <div className="col personnalCol">
                            <h2 className="text-center titles text-green-700 mb-1">MelTextureGuesser</h2>
                            <Card className="personnal-card border-green-700 melTexturesGuesserCard cursor-pointer" onClick={() => setMelTextureGuesserVisible(true)}>
                                <div></div>

                                <div className="w-full flex justify-content-center bottom-0">
                                    <Button label="Details" className="mt-3 cardButton" onClick={() => setMelTextureGuesserVisible(true)} outlined/>
                                </div>
                            </Card>
                        </div>
                        <div className="col personnalCol">
                            <h2 className="text-center titles text-blue-400 mb-1">Gstm</h2>
                            <Card className="personnal-card border-blue-400 ghostStartTimeModifierCard cursor-pointer" onClick={() => setGstmVisible(true)}>
                                <div></div>

                                <div className="w-full flex justify-content-center bottom-0">
                                    <Button label="Details" className="mt-3 cardButton" onClick={() => setGstmVisible(true)} outlined/>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
            <Gstm visible={gstmVisible} setVisible={setGstmVisible}/>
            <MelTextureGuesser visible={melTextureGuesserVisible} setVisible={setMelTextureGuesserVisible}/>
            <Portfolio visible={portfolioVisible} setVisible={setPortfolioVisible}/>
            <SweetAiChat visible={sweetAiChatVisible} setVisible={setSweetAiChatVisible}/>
            <FakeTradiing visible={fakeTradiingVisible} setVisible={setFakeTradiingVisible}/>
        </>
    )

}